<template>
  <v-card class="pb-12">
    <v-card-text class="info-box">
      <v-row class="d-flex justify-center mb-4">
        <v-col cols="12" md="10" class="text-left">
          <h2
            aria-live="assertive"
            class="text-h2 text-center mt-4 mb-4"
            :class="$vuetify.display.xs ? 'font-size--16' : ''"
          >
            {{ $t('L_start_new_policy') }}
          </h2>
          <h4 class="mt-3 font-weight-regular text-h4 mb-0 pb-0">
            {{ $t('L_policy_info') }}
          </h4>
        </v-col>
        <v-col cols="12" md="9" v-if="!hasNoTabacoRate" class="mx-0 px-0 mt-2">
          <v-card-actions class="justify-center mx-0 px-0">
            <OnexRadioGroup
              id="tobacco"
              :model-value="tobaccoSelection"
              :mandatory="true"
              label=" "
              @update:model-value="selectTobaccoOption"
            >
              <OnexRadio
                class="mb-4"
                v-for="(option, index) in tobaccoOptions"
                :id="option.id || 'radio_input_' + index"
                :key="option.label"
                :label="option.label"
                :value="option.value"
              >
                <template #label>
                  <span :class="$vuetify.display.smAndUp ? 'font-size--16' : 'font-size--14'">
                    {{ $t(`${option.label}`) }}
                  </span>
                </template>
              </OnexRadio>
            </OnexRadioGroup>
          </v-card-actions>
        </v-col>
        <v-col
          v-if="!hasNoTabacoRate"
          cols="12"
          md="8"
          class="text-left justify-left mb-4 text-h4 font-weight-regular"
        >
          <span>
            {{ $t('L_nontobacco_is_for_no_tobacco') }}
          </span>
        </v-col>
      </v-row>
      <v-divider />
      <v-row justify="center" class="">
        <v-col cols="12" md="10" class="text-left mb-4 mt-4 text-h4 font-weight-regular pb-0">
          <span>
            {{ $t('L_choose_the_termnow_35', { insuranceSelected: getInsuranceSelected }) }}
          </span>
        </v-col>
      </v-row>
      <v-row justify="center" class="background-light-grey pt-0 mt-0">
        <v-col cols="12" md="10" class="py-4 text-h4 font-weight-regular">
          <span>{{ $t('L_option_explanation') }}</span>
          <div class="mt-4 text-left">
            {{ $t('L_contact_your_representative_if') }}
          </div>
        </v-col>
        <v-col cols="12" md="10">
          <!-- This is for NON xs Screen -->
          <v-data-table
            v-if="!$vuetify.display.xs"
            v-model="selected"
            :items="electionOptions"
            item-key="name"
            hide-default-footer
            striped="even"
            :hover="true"
          >
            <template v-slot:headers>
              <tr>
                <th
                  v-for="(item, index) in headers"
                  :key="item.value"
                  v-show="!(index === 2 && tobaccoSelection === '')"
                  :class="index === 0 ? 'text-left w-50' : 'text-right'"
                  class="pb-1"
                >
                  <span v-html="headers[index].text" />
                </th>
              </tr>
            </template>
            <template v-slot:item="props">
              <tr class="valignTextMiddle">
                <td>
                  <OnexRadioGroup
                    id="election"
                    v-model="selectedOption"
                    :mandatory="true"
                    hideLabel
                  >
                    <OnexRadio
                      :id="'election-option-' + props.index"
                      :value="(props.item as any).electionOption"
                      :for="'election-option-' + props.index"
                      :label="`${$t('L_election_option')} ${props.index + 1}:`"
                    >
                      <template #label>
                        <span class="font-weight-semibold">
                          {{ `${$t('L_election_option')} ${props.index + 1}:` }}
                        </span>
                      </template>
                    </OnexRadio>
                  </OnexRadioGroup>
                </td>
                <td class="font-size--14 text-right">
                  {{ (props.item as any).amountOfInsurance }}
                </td>
                <td class="font-size--14 text-right" v-if="tobaccoSelection !== ''">
                  {{ (props.item as any).monthlyBankDraft }}
                </td>
              </tr>
            </template>
          </v-data-table>
          <!-- This is for xs Screen -->
          <v-card class="font-size--14" v-if="$vuetify.display.xs">
            <v-card-title class="font-size--14 my-4">
              <span class="font-weight-semibold" v-html="headers[0].text" />
            </v-card-title>
            <v-card-text v-for="(item, index) in electionOptions" :key="index" class="pt-0">
              <v-row :class="$vuetify.display.xs ? 'mt-n4' : ''">
                <v-col cols="12" class="text-left pt-0">
                  <OnexRadioGroup
                    id="election-sm"
                    v-model="selectedOption"
                    :mandatory="true"
                    hideLabel
                    hideDetails
                  >
                    <OnexRadio
                      class="xsSelectionBlock"
                      id="election-option-sm"
                      :value="item.electionOption"
                    >
                      <template #label>
                        <span class="font-size--14 font-weight-semibold">
                          {{ `${$t('L_election_option')} ${+index + 1}:` }}
                        </span>
                      </template>
                    </OnexRadio>
                  </OnexRadioGroup>
                </v-col>
              </v-row>
              <v-row :class="$vuetify.display.xs ? 'ml-4 mt-0' : ''">
                <v-col
                  cols="12"
                  class="d-flex align-start justify-space-between"
                  :class="tobaccoSelection !== '' ? 'mb-0' : 'mb-5'"
                >
                  <span class="font-weight-semibold" v-html="headers[1].text" />
                  <span v-html="item.amountOfInsurance" />
                </v-col>
              </v-row>
              <v-row v-if="tobaccoSelection !== ''" :class="$vuetify.display.xs ? 'pt-0 ml-4' : ''">
                <v-col cols="12" class="d-flex align-center justify-space-between mb-5">
                  <span class="font-weight-semibold" v-html="headers[2].text" />
                  <span v-html="item.monthlyBankDraft" />
                </v-col>
              </v-row>
              <v-divider v-if="index !== electionOptions.length - 1" />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="10"
          py-4
          class="font-size--12"
          :class="$vuetify.display.xs ? 'text-xs-center' : 'text-xs-right'"
        >
          {{ $t('L_policy_fee_is') }}
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" class="mb-12 justify-center d-flex">
          <OnexButton
            role="link"
            color="primary"
            width="220"
            :disabled="!selectedOption || !(tobaccoSelection === 0 || tobaccoSelection === 1)"
            @click="continueNext"
          >
            {{ $t('L_next') }}
          </OnexButton>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { currency, formatDate } from '@/shared/util/formatters';
import { useGlobalStore } from '@/stores/global/global.store';
import { mapActions, mapState } from 'pinia';
import { useChildRiderStore } from '../../store/childrider.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { OnexButton, OnexRadioGroup, OnexRadio, OnexLabelTooltip } from '@primerica/onex-ui-lib';

const componentOptions: ComponentOptions = {
  name: 'CRCStepB',
  components: {
    OnexButton,
    OnexRadioGroup,
    OnexRadio,
    OnexLabelTooltip,
  },
  created() {
    /*
     * for all NextGen CRC packets
     * Tobacco / Non-Tobacco Question: Default to 'Non-Tobacco'
     * Do not display the Tobacco / Non-Tobacco Question question on the page
     */
    if (this.hasNoTabacoRate) {
      this.tobaccoSelection = 1;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  data: () => ({
    areAllOptionsSelected: false,
    tobaccoSelection: '',
    selected: [],
    selectedOption: null,
  }),
  computed: {
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
    }),
    ...mapState(useGlobalStore, {
      dateFormat: 'getDateFormat',
    }),
    ...mapState(useChildRiderStore, {
      selectedPackage: 'NPPackage',
      NPSelectedOption: 'NPSelectedOption',
      NPPackage: 'NPPackage',
      insuranceSelected: 'insuranceSelected',
      newPolicy: 'newPolicy',
    }),
    ...mapState(usePolicyStore, {
      policy: 'currentPolicy',
    }),
    electionOptions() {
      return this.tobaccoSelection === 1 ? this.nonTobaccoOptionsList : this.tobaccoOptionsList;
    },
    tobaccoOptions() {
      // Non nextGen
      if (!this.hasNoTabacoRate) {
        return [
          {
            label: this.$t('L_tobacco'),
            value: 0,
          },
          {
            label: this.$t('L_nontobacco'),
            value: 1,
          },
        ];
      }
      // NextGen
      return [
        {
          label: this.$t('L_nontobacco'),
          value: 1,
        },
      ];
    },
    tobaccoOptionsList() {
      return this.selectionOptionsList.filter(
        (option: { electionOption: string; amountOfInsurance: string; monthlyBankDraft: string }) =>
          option.electionOption.includes('T') && option.amountOfInsurance
      );
    },
    nonTobaccoOptionsList() {
      return this.selectionOptionsList.filter(
        (option: { electionOption: string; amountOfInsurance: string; monthlyBankDraft: string }) =>
          option.electionOption.includes('N') && option.amountOfInsurance
      );
    },
    selectionOptionsList() {
      const policyElections: object[] = [];
      const objectArray = Object.entries(
        this.selectedPackage?.selectionOptions ? this.selectedPackage?.selectionOptions : []
      );

      objectArray.forEach(([key, value]: [key: string, value: unknown]) => {
        const v = value as { faceAmount?: string; premiumAmount?: string };
        policyElections.push({
          electionOption: key,
          amountOfInsurance: currency(v.faceAmount, 2),
          monthlyBankDraft: currency(v.premiumAmount, 2),
        });
      });
      return policyElections;
    },
    hasNoTabacoRate() {
      /*
      Identifying NextGen CRC packets (see https://pri-jira.atlassian.net/browse/MYP-2896):
      Per LifeOps team (Chris Thompson), there will not be a NextGen indicator added to the current CRC service / api
      to denote which policies are NextGen versus pre-NextGen. Instead, NextGen CRC packets will not have tobacco rates.
      The following CRC_EVENT_LOG table data fields should contain zero (0 or 0.00) values:
      OPT1_T_PREM, OPT2_T_PREM, OPT3_T_PREM, OPT4_T_PREM, OPT5_T_PREM */
      const options = Object.entries(
        this.selectedPackage?.selectionOptions ? this.selectedPackage?.selectionOptions : []
      );
      const tobaccoRates: number[] = [];
      if (!options.length) {
        return false;
      }
      // filter out the tobacco rates
      options.forEach(([key, value]: [key: string, value: unknown]) => {
        if (key.includes('T')) {
          const v = value as { premiumAmount?: string };
          tobaccoRates.push(Number(v.premiumAmount));
        }
      });
      // check if packets does not have tobacco rates (premium amounts have 0 or 0.00 values)
      return tobaccoRates.every((e) => e <= 0);
    },
    getInsuranceSelected() {
      if (this.hasNoTabacoRate === false) {
        const compCodes = ['04', '05', '10'];
        if (
          compCodes.some((eachCompanyCode) =>
            this.NPPackage?.policyCompNum.includes(eachCompanyCode)
          )
        ) {
          return 'TermNow35';
        }
        // returns if comp code is 34
        return 'TermNow30';
      }
      const compCodes1 = ['04'];
      const compCodes2 = ['34'];
      const compCodes3 = ['05', '10'];
      if (
        compCodes1.some((eachCompanyCode) =>
          this.NPPackage?.policyCompNum.includes(eachCompanyCode)
        )
      ) {
        return 'PowerTerm 35';
      } else if (
        compCodes2.some((eachCompanyCode) =>
          this.NPPackage?.policyCompNum.includes(eachCompanyCode)
        )
      ) {
        return 'PowerTerm 30';
      } else if (
        compCodes3.some((eachCompanyCode) =>
          this.NPPackage?.policyCompNum.includes(eachCompanyCode)
        )
      ) {
        if (this.locale === 'fr_CA') {
          return 'Temporaire Puissance Primerica 35';
        }
        return 'Primerica PowerTerm 35';
      }
      return 'PowerTerm 35';
    },
    headers() {
      return [
        {
          text: `${this.$t('L_new_policy_election')} ${formatDate(
            this.selectedPackage?.newIssueDt,
            this.dateFormat
          )}`,
          align: 'left',
          sortable: false,
          value: 'electionOption',
        },
        {
          text: `${this.$t('L_amount_of_insurance')} `,
          align: 'right',
          value: 'amountOfInsurance',
          sortable: false,
        },
        {
          text: this.headerTimeLabelForChart,
          align: 'right',
          value: 'monthlyBankDraft',
          sortable: false,
        },
      ];
    },
    headerTimeLabelForChart() {
      let timeLabel;
      if (this.policy?.billingForm === 'A1') {
        if (this.policy?.billingMode === '01') {
          timeLabel = this.$t('L_quarterly_premium'); // Changed as per Dewayne who mentioned that A1 01 would be coming in as Quarterly
        } else if (this.policy?.billingMode === '03') {
          timeLabel = this.$t('L_quarterly_premium');
        } else if (this.policy?.billingMode === '06') {
          timeLabel = this.$t('L_semi_annual_premium');
        } else if (this.policy?.billingMode === '12') {
          timeLabel = this.$t('L_annual_premium');
        } else {
          timeLabel = this.$t('L_monthly_premium');
        }
      } else if (
        this.policy?.billingForm === 'C2' ||
        this.policy?.billingForm === 'D2' ||
        this.policy?.billingForm === 'H1'
      ) {
        timeLabel = this.$t('L_quarterly_premium');
      } else {
        timeLabel = this.$t('L_monthly_premium');
      }
      return timeLabel;
    },
    formValid() {
      if (
        this.NPSelectedOption != null &&
        this.tobaccoSelection != null &&
        this.NPSelectedOption !== '' &&
        this.tobaccoSelection !== ''
      ) {
        const tobbOption = this.tobaccoSelection === 1 ? 'N' : 'T';
        const covOption = this.NPSelectedOption.substr(0, 1);
        const value = covOption + tobbOption;
        const selected = this.selectedPackage?.selectionOptions;
        this.setNPSelectedFaceAmount(selected[value]?.faceAmount);
        this.setNPSelectedPremiumAmount(selected[value]?.premiumAmount);
      }
      return this.NPSelectedOption !== '' && this.tobaccoSelection !== '';
    },
  },
  methods: {
    ...mapActions(useChildRiderStore, {
      next: 'crcNext',
      setNPSelectedOption: 'setNPSelectedOption',
      setNPSelectedFaceAmount: 'setNPSelectedFaceAmount',
      setNPSelectedPremiumAmount: 'setNPSelectedPremiumAmount',
    }),
    selectTobaccoOption(value: number) {
      this.tobaccoSelection = value;
      this.selectedOption = '';
    },
    continueNext() {
      this.setNPSelectedOption(this.selectedOption);
      const selected = this.selectedPackage.selectionOptions;
      this.setNPSelectedFaceAmount(selected[this.selectedOption].faceAmount);
      this.setNPSelectedPremiumAmount(selected[this.selectedOption].premiumAmount);
      this.next();
    },
  },
};

export default defineComponent(componentOptions);
</script>
<style lang="scss" scoped>
.valignTextMiddle {
  vertical-align: middle;
}

.nonxsSelectionBlock label {
  font-size: 14px;
}

.xsSelectionBlock label {
  font-size: 14px;
  font-weight: bold;
  color: #333333;
}

.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}

.v-input {
  padding-bottom: 0px;
}

.borderbottom {
  padding-bottom: 15px;
  border-bottom: 1px solid gray;
}

.mt--5 {
  margin-top: -5px;
}

#label-tooltip .label .v-icon__svg {
  display: none !important;
}

.info-box {
  max-width: 760px;
  margin: 0 auto;
  text-align: left;
}

[data-comp-type='onex-radio-group'] {
  margin-top: 0 !important;
}
</style>
